import { QueueState } from 'lib_ts/enums/machine-msg.enum';
import { IMachineModel } from 'lib_ts/interfaces/modelling/i-machine-model';
import { useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

const useSyncReadyToTrain = (props: {
  loading: boolean; // i.e. machine cx loading
  activeModel: IMachineModel | undefined;
  queueState: QueueState;
  ignoreGameStatus: boolean;
}) => {
  const isInGame = useAuthStore((s) => s.isInGame);
  const loadingTms = useTrainedMsStore((s) => s.loading);

  useEffect(() => {
    useTrainedMsStore.setState({
      readyToTrain: (() => {
        if (props.loading) {
          return false;
        }

        if (!props.activeModel) {
          // model is not loaded yet
          return false;
        }

        if (props.activeModel?.calibration_only) {
          // model can only be used for calibration
          return false;
        }

        if (!props.ignoreGameStatus && isInGame) {
          // some machines can train during games
          return false;
        }

        if (props.queueState !== QueueState.Active) {
          // only the active user can train
          return false;
        }

        if (loadingTms) {
          // wait until TMS has loaded to know what needs training
          return false;
        }

        return true;
      })(),
    });
  }, [
    props.loading,
    props.activeModel,
    props.ignoreGameStatus,
    props.queueState,
    isInGame,
    loadingTms,
  ]);
};

export default useSyncReadyToTrain;
